import { render } from "./FooterElement.vue?vue&type=template&id=1ceb323a"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__